import { css } from '@emotion/react';
import { theme } from 'global';

export const checkboxItem = css`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: stretch;
  gap:16px
  width: 100%;
`;

export const checkboxGroup = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const checkboxAndLabel = css`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const checkboxLabel = css`
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const checkbox = css`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const subCopy = css`
  color: ${theme.colors.neutral[600]} !important;
  line-height: 18px;
  font-weight: 400;
  strong {
    color: ${theme.colors.neutral[600]} !important;
  }
`;

export const details = css`
  width: 100%;
  padding: 0 0 0 36px;
`;

export const headingStyle = (isChecked) => css`
  color: ${isChecked ? theme.colors.primary.medium : theme.colors.secondary};
  line-height: 21px;
  font-weight: 500;
`;

export const divider = css`
  margin: 16px 0;
`;

export const sidebar = (isMobile) => css`
  z-index: 1301 !important;

  & .MuiPaper-root {
    display: flex;
    flex-direction: column;
    width: ${isMobile ? '100vw' : '500px'};
    height: 100vh;
    padding: 24px;
    gap: 24px;
    ${isMobile && 'padding-bottom: 80px;'}
  }

  & > .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.4);
    mix-blend-mode: normal;
    backdrop-filter: blur(4px);
  }
`;

export const sidebarWordingTitle = css`
  height: 26px;
  display: flex;
  justify-content: space-between;
`;

export const backButton = css`
  width: auto !important;
  min-width: 50px !important;
  padding: 6px 12px !important;
  font-size: 12px !important;
  height: 32px !important;
`;

export const submitButton = css`
  width: 166px;
  radius: 8px;
`;

export const closeIcon = css`
  min-width: 24px;
  min-height: 24px;
  cursor: pointer;
`;

export const buttonControl = (isMobile) => css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: 100%;

  ${isMobile &&
  `
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    padding: 16px 24px;
    border-top: 1px solid ${theme.colors.neutral[200]};
    z-index: 1301;
    justify-content: space-between;
    margin-top: 0;
  `}
`;

export const hifive = css`
  width: 96px;
  height: 96px;
`;

export const submittedContent = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  gap: 16px;
`;

export const headerContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 26px;
`;

export const closeIconContainer = css`
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 1;
`;
